import SvgIcon from '@mui/material/SvgIcon';
import * as React from 'react';
const SvgCheck = (props)=>/*#__PURE__*/ React.createElement(SvgIcon, {
        ...props,
        viewBox: "0 0 24 24"
    }, /*#__PURE__*/ React.createElement("path", {
        d: "M19.727 6.569c.364.343.364.897 0 1.207l-9.434 9.63c-.304.373-.847.373-1.183 0l-4.859-4.96c-.335-.31-.335-.865 0-1.208a.85.85 0 0 1 1.213 0l4.253 4.345 8.827-9.014c.336-.34.879-.34 1.183 0"
    }));
export default SvgCheck;
